import React, { useEffect, useState } from "react";
import logo from "../../../Assets/AppComponent/Qpms/White_logo.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import validator from "validator";
import Email from "../../AppComponent/InputFields/Email";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import "../../../StyleSheet/MainComponent/ForgotPassword/ForgotPassword.scss";
import { useDispatch, useSelector } from "react-redux";
import { getForgotPasswordPerson } from "../../../Redux/Slice";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import { useNavigate } from "react-router-dom";
const Forgotpassword = (props) => {
  const { Lang, Language } = props;
  console.log(Lang, Language, "langs");
  const EnglishData = data;
  const HindiData = hindiDatas;
  const Datas = {
    email: "",
  };
  const State = useSelector((State) => State);
   const navigate = useNavigate()

  const [InputData, setInputDatas] = useState(Datas);
  const [EmailError, setEmailError] = useState("");
  const [label, setLabel] = useState("Email");
  const HandleChanges = (e) => {
    setInputDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
  const dispatch = useDispatch();
  const handleSubmit = () => {
    var a = 0;
    // ErrorEmail(a)
    // Passworderror(a)
    if (!validator.isEmail(InputData.email)) {
      setEmailError("*Enter valid mail id");
      a = 1;
    }

    if (a == 0) {
      ///----Dispatch
       const payload ={
        InputData:InputData,
        Funcations: () => {
          // Your function logic here
          console.log('Function called');
          navigate("/verify")

        },

       }
      dispatch(getForgotPasswordPerson(payload));
    }
  };
  return (
    <>
      <div className="qpms-loginpage ">
      {/* <div className="uds-ForgotPassword"> */}
          <div className="  Conatiningpart">
            <div className="Welcomepart">
              {/* <div className="Toppart">
                <img className="desingimg" src={toppart} />
              </div> */}
              <div className="bottompart">
              {/* leftSidepartREST */}
                <div className=" leftSidepart">
                  <div className="Logo">
                    <img className="logoUds" src={logo} />
                  </div>
                  {State.Language.Language == "English" ? (
                    <>
                      {EnglishData.LeftSide.Welcome.map((item) => (
                        <div className="
                        //  Heading
                           Content" id={item.id}>
                          <h1>{item.Heading}</h1>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {hindiDatas.LeftSide.Welcome.map((item) => (
                        <div className="
                        //  Heading 
                          Content" id={item.id}>
                          <h1>{item.Heading}</h1>
                        </div>
                      ))}
                    </>
                  )}
                  {/* {State.Language.Language == "English" ? (
                    <>
                      {EnglishData.LeftSide.Content.ContentPassword.map(
                        (item) => (
                          <p className="reset">{item.para1}</p>
                        )
                      )}
                    </>
                  ) : (
                    <>
                      {hindiDatas.LeftSide.Content.ContentPassword.map(
                        (item) => (
                          <p className="reset">{item.para1}</p>
                        )
                      )}
                    </>
                  )} */}

                  {/* {State.Language.Language == "English" ? (
                    <>
                      {EnglishData.LeftSide.Content2.map((item) => (
                        <div className="para">
                          <p>{item.para2}</p>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {hindiDatas.LeftSide.Content2.map((item) => (
                        <div className="para">
                          <p>{item.para2}</p>
                        </div>
                      ))}
                    </>
                  )} */}

                  {/* --------Details-------------------- */}
                  {/* <div className="Details">
                    {State.Language.Language == "English" ? (
                      <>
                        {EnglishData.LeftSide.Details.Details2.map((item) => (
                          <p key={item.id}>{item.Details}</p>
                        ))}
                      </>
                    ) : (
                      <>
                        {hindiDatas.LeftSide.Details.Details2.map((item) => (
                          <p key={item.id}>{item.Details}</p>
                        ))}
                      </>
                    )}

                    <div className="Arrow">
                      <img src={Arrow} />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className=" loginpart">
              <div className="Loginwrapped">
                <div className="Udslog">
                  {State.Language.Language == "English" ? (
                    <>
                      {EnglishData.LeftSide.ForgotPage.map((item) => (
                        <h4 className="heading" key={item.id}>
                          {item.Forgot}
                        </h4>
                      ))}
                    </>
                  ) : (
                    <>
                      {HindiData.LeftSide.ForgotPage.map((item) => (
                        <h4 className="heading" key={item.id}>
                          {item.Forgot}
                        </h4>
                      ))}
                    </>
                  )}

                  <div className="Input-Inner">
                    <Email
                      value={InputData.email}
                      onChange={(e) => {
                        setEmailError("");
                        HandleChanges(e);
                      }}
                      Error={EmailError}
                      label={label}
                    />
                  </div>
                  <div className="SubmitButton">
                    {State.Language.Language == "English" ? (
                      <>
                        {EnglishData.LeftSide.Button.Button2.map((item) => (
                          <CustomButton
                            children="Submit"
                            onClick={handleSubmit}
                            type="submit"
                            className="ButtonCSS"

                          >
                            {item.ButtonNameSendOTP}
                          </CustomButton>
                        ))}
                      </>
                    ) : (
                      <>
                        {hindiDatas.LeftSide.Button.Button2.map((item) => (
                          <CustomButton
                            children="Submit"
                            onClick={handleSubmit}
                            type="submit"
                            className="ButtonCSS"

                          >
                            {item.ButtonNameSendOTP}
                          </CustomButton>
                        ))}
                      </>
                    )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        {/* </div> */}
      </div>
    </>
  );
};

export default Forgotpassword;
